module.exports = __webpack_public_path__ + "static/media/dixiebg.e094295b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dixiebg.png
// module id = 21
// module chunks = 0